import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-secondary flex items-center text-2xl font-basier font-medium" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 lg:gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "correction"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Dodaj korektę", -1)
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "h-full" }
const _hoisted_7 = {
  key: 0,
  class: "h-full w-1/2"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "text-red"
}
const _hoisted_11 = { class: "flex justify-end" }
const _hoisted_12 = { class: "flex flex-col items-end" }
const _hoisted_13 = { class: "flex justify-end" }
const _hoisted_14 = {
  key: 0,
  class: "text-red"
}

import { computed, ref, onBeforeUnmount, reactive } from 'vue'
import {
    UiHeading,
    UiContainer,
    UiCard,
    UiButton,
    UiCardText,
    UiCheckbox,
} from '@/components/common/ui'
import AddInvoiceFile from '@/components/addInvoice/AddInvoiceFile.vue'
import AddInvoiceCorrection from '@/components/addInvoice/AddInvoiceCorrection.vue'
import InvoiceAttachments from '@/components/addInvoice/InvoiceAttachments.vue'
import InvoiceAdvicesList from '@/components/addInvoice/InvoiceAdvicesList.vue'
import { AppLoadingContent } from '@/components/common'
import { useAdviceStatuses } from '@/composables/useAdvicesStatuses'

import {
    useAdviceDocuments,
    IPostInvoice,
    InvoiceFormModes,
} from '@/composables/useAdviceDocuments'
import { useAdviceDeliveryReactions } from '@/composables/useAdviceDeliveryReactions'
import { useNotifications } from '@/composables/useNotifications'
import router from '@/router'
import { DocumentFileImage } from '@/types/partials'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { pushSuccess, pushFail } = useNotifications()

const {
    selectedAdvices,
    fetchInvoiceData,
    invoiceData,
    addInvoice,
    editInvoice,
    addInvoiceCorrection,
    isLoading: adviceDocumentsLoading,
    clearInvoiceData,
    invoiceFormMode,
    editedInvoiceName,
    setInvoiceFormMode,
    removeAllSelectedAdvicesFromStorage,
    correctionValue,
    attachmentDescriptions,
    validateAll,
} = useAdviceDocuments()

const { fetchAdviceStatuses } = useAdviceStatuses()
const {
    fetchAdviceDeliveryReactions,
    adviceDeliveryReactions,
    clearAdviceDeliveryReactionsData,
    loading: adviceDeliveryReactionsLoading,
} = useAdviceDeliveryReactions()

fetchInvoiceData().then(() => {
    // fetch advices reactions
    selectedAdvices.value.forEach(item => {
        fetchAdviceDeliveryReactions(item.id, true)
    })
})
fetchAdviceStatuses()
const deliveryReactionsImages = computed(() => {
    return adviceDeliveryReactions.value.items.reduce((prevItem, currentItem) => {
        currentItem.images.forEach(item => (item.adviceId = currentItem.adviceId))
        return prevItem.concat(currentItem.images)
    }, [] as DocumentFileImage[])
})
const checkedDeliveryReactionsImages: { images: number[] } = reactive({ images: [] })
const handleDeliveryReactionsImages = (id: number) => {
    const itemPos = checkedDeliveryReactionsImages.images.findIndex(imageId => id === imageId)
    if (itemPos === -1) {
        checkedDeliveryReactionsImages.images.push(id)
    } else {
        checkedDeliveryReactionsImages.images.splice(itemPos, 1)
    }
}
onBeforeUnmount(() => {
    setInvoiceFormMode(InvoiceFormModes.ADD)
    clearInvoiceData()
    clearAdviceDeliveryReactionsData()
})

const loadingText = computed(() => {
    if (invoiceFormMode.value === InvoiceFormModes.EDIT) {
        return 'Zapisywanie zmian'
    }
    if (invoiceFormMode.value === InvoiceFormModes.CORRECTION) {
        return 'Dodawanie korekty'
    }
    return 'Dodawanie faktury'
})
const formTitle = computed(() => {
    if (invoiceFormMode.value === InvoiceFormModes.EDIT) {
        return `Edytuj fakturę ${editedInvoiceName.value ? editedInvoiceName.value : ''}`
    }
    if (invoiceFormMode.value === InvoiceFormModes.CORRECTION) {
        return `Korekta faktury ${editedInvoiceName.value ? editedInvoiceName.value : ''}`
    }
    return 'Dodaj dokumenty do zleceń'
})
const totalQuantity = computed(() => {
    if (!selectedAdvices.value || selectedAdvices.value.length === 0) return
    return selectedAdvices.value.map(e => e.quantity).reduce((prev, curr) => prev + curr)
})

const submitButtonFired = ref<boolean>(false)

// form validation
const invoiceNumberError = computed(() => invoiceDetails.value.invoiceNumber === '')
const ksefNumberError = computed(() => invoiceDetails.value.ksefNumber === '')
const invoiceFileError = computed(() => {
    if (submitButtonFired.value) {
        if (invoiceDetails.value.invoiceFile) {
            return Object.keys(invoiceDetails.value.invoiceFile).length < 1
        }
        return true
    }
    return false
})
const correctionFileError = computed(() => {
    if (invoiceFormMode.value !== InvoiceFormModes.CORRECTION) return false
    if (submitButtonFired.value) {
        if (invoiceDetails.value.correctionFile) {
            return Object.keys(invoiceDetails.value.correctionFile).length < 1
        }
        return true
    }
    return false
})
const attachmentsError = computed(() => {
    if (invoiceFormMode.value === InvoiceFormModes.ADD) {
        return (
            submitButtonFired.value &&
            invoiceDetails.value.attachmentFiles.length === 0 &&
            checkedDeliveryReactionsImages.images.length === 0
        )
    } else if (invoiceFormMode.value === InvoiceFormModes.CORRECTION) {
        return false
    } else {
        return submitButtonFired.value && invoiceDetails.value.attachmentFiles.length === 0
    }
})
const advicesError = computed(() => {
    return submitButtonFired.value && selectedAdvices.value.length === 0
})
const isFormValid = computed(() => {
    return (
        validateAll.value &&
        (!invoiceFileError.value || !ksefNumberError.value) &&
        !invoiceNumberError.value &&
        !attachmentsError.value &&
        !advicesError.value &&
        !correctionFileError.value
    )
})
// end form validation

const invoiceDetails = computed(() => invoiceData.value)

const showValidationError = computed(() => {
    return (
        submitButtonFired.value &&
        (!validateAll.value ||
            attachmentsError.value ||
            (ksefNumberError.value && invoiceFileError.value) ||
            advicesError.value ||
            correctionFileError.value)
    )
})

const saveInvoice = (payload: IPostInvoice) => {
    return new Promise((resolve, reject) => {
        if (invoiceFormMode.value === InvoiceFormModes.EDIT) {
            editInvoice(payload)
                .then(() => resolve('Faktura edytowana pomyślnie '))
                .catch(err => reject(err))
        } else if (invoiceFormMode.value === InvoiceFormModes.CORRECTION) {
            payload.filenamePdf = invoiceDetails.value.correctionFile.name
            payload.base64Pdf = invoiceDetails.value.correctionFile.base64 as string

            addInvoiceCorrection(payload)
                .then(() => resolve('Korekta faktury dodana pomyślnie '))
                .catch(err => reject(err))
        } else {
            payload.deliveryReactionImagesIds = checkedDeliveryReactionsImages.images
            addInvoice(payload)
                .then(() => resolve('Faktura dodana pomyślnie '))
                .catch(err => reject(err))
        }
    })
}

const onInvoiceSave = () => {
    submitButtonFired.value = true

    const amount =
        invoiceFormMode.value === InvoiceFormModes.CORRECTION
            ? correctionValue.value
            : invoiceDetails.value.invoiceValue

    const payload: IPostInvoice = {
        amount: Number(amount),
        number: invoiceDetails.value.invoiceNumber,
        ksefNumber: invoiceDetails.value.ksefNumber,
        filenamePdf: invoiceDetails.value.invoiceFile.name,
        base64Pdf: invoiceDetails.value.invoiceFile.base64 as string,
        adviceIds: invoiceDetails.value.advices.map(e => e.id),
        attachments:
            attachmentDescriptions.value
                .map(item => item.pages)
                .reduce((next, curr) => {
                    return curr.concat(next)
                }, []) || [],
    }

    if (invoiceFormMode.value !== InvoiceFormModes.ADD) {
        payload.id = invoiceDetails.value.editedInvoiceId
    }

    if (invoiceNumberError.value) {
        pushFail('Uzupełnij numer faktury, to pole jest wymagane.')
    }

    if (invoiceFileError.value && ksefNumberError.value) {
        pushFail('Uzupełnij numer KseF lub dodaj FV do zlecenia.')
    }

    if (!isFormValid.value) {
        pushFail('Nie wszystkie wymagane pola są poprawnie wypełnione.')
        return
    }

    saveInvoice(payload)
        .then(async response => {
            await clearInvoiceData()
            await clearAdviceDeliveryReactionsData()
            await removeAllSelectedAdvicesFromStorage()
            pushSuccess(response as string)
            router.push({ name: 'invoices' })
        })
        .catch(error => {
            if (error instanceof Error) {
                pushFail(`Wystąpił błąd. Spróbuj ponownie później. ${error.message}`)
            }
        })
}

return (_ctx: any,_cache: any) => {
  const _component_IconWeight = _resolveComponent("IconWeight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), {
      "can-go-back": "",
      title: _unref(formTitle)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_IconWeight, { class: "mr-3" }),
          _createTextVNode(" Łączny tonaż : " + _toDisplayString(_unref(totalQuantity)) + " t ", 1)
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_unref(UiContainer), null, {
      default: _withCtx(() => [
        _createVNode(_unref(AppLoadingContent), {
          text: _unref(loadingText),
          "is-loading": _unref(adviceDocumentsLoading) || _unref(adviceDeliveryReactionsLoading),
          "full-screen": "",
          "show-content-on-loading": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(UiCard), {
                "custom-class": 'pb-10',
                class: "col-span-2 lg:col-span-1",
                title: "Dodana faktura"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({
                                'invoice-files-wrapper':
                                    _unref(invoiceFormMode) === _unref(InvoiceFormModes).CORRECTION,
                            })
                  }, [
                    _createVNode(AddInvoiceFile, {
                      id: 'invoiceUpload',
                      class: "invoice",
                      error: _unref(ksefNumberError) && _unref(invoiceFileError),
                      "disable-remove": _unref(invoiceFormMode) === _unref(InvoiceFormModes).CORRECTION,
                      "show-input": _unref(invoiceFormMode) !== _unref(InvoiceFormModes).CORRECTION,
                      "file-upload-enable": 
                                    _unref(invoiceFormMode) !== _unref(InvoiceFormModes).CORRECTION
                                
                    }, null, 8, ["error", "disable-remove", "show-input", "file-upload-enable"]),
                    (_unref(invoiceFormMode) === _unref(InvoiceFormModes).CORRECTION)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _hoisted_4,
                          _createVNode(AddInvoiceCorrection, {
                            id: 'correctionUpload',
                            class: "mt-2",
                            error: _unref(correctionFileError)
                          }, null, 8, ["error"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }),
              _createVNode(_unref(UiCard), {
                class: "col-span-2 lg:col-span-1",
                title: "Załączniki",
                "custom-class": 'pb-10'
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(InvoiceAttachments, { error: _unref(attachmentsError) }, null, 8, ["error"])
                    ]),
                    (
                                    _unref(invoiceFormMode) === _unref(InvoiceFormModes).ADD &&
                                        _unref(adviceDeliveryReactions).items &&
                                        _unref(adviceDeliveryReactions).items.length > 0
                                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_unref(UiCardText), { title: "Załączniki ze zleceń" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryReactionsImages), (reactionImages) => {
                                return (_openBlock(), _createBlock(_unref(UiCheckbox), {
                                  id: `adviceDeliveryReactions${reactionImages.id}`,
                                  key: `adviceDeliveryReactions${reactionImages.id}`,
                                  class: "whitespace-nowrap",
                                  onChange: ($event: any) => (handleDeliveryReactionsImages(reactionImages.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" AW " + _toDisplayString(reactionImages.adviceId) + ": ", 1),
                                    (reactionImages.documentType)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(reactionImages.documentType?.name), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_9, " Bez typu "))
                                  ]),
                                  _: 2
                                }, 1032, ["id", "onChange"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(UiCard), {
              class: "col-span-2 lg:col-span-1",
              title: "Lista zleceń na fakturze"
            }, {
              content: _withCtx(() => [
                (_unref(selectedAdvices).length > 0)
                  ? (_openBlock(), _createBlock(InvoiceAdvicesList, {
                      key: 0,
                      advices: _unref(selectedAdvices)
                    }, null, 8, ["advices"]))
                  : _createCommentVNode("", true),
                (_unref(advicesError))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Faktura musi zawierać co najmniej jedno zlecenie. "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_unref(validateAll)) + " " + _toDisplayString(!_unref(invoiceFileError) || !_unref(ksefNumberError)) + " " + _toDisplayString(!_unref(invoiceNumberError)) + " " + _toDisplayString(!_unref(attachmentsError)) + " " + _toDisplayString(!_unref(advicesError)) + " " + _toDisplayString(!_unref(correctionFileError)) + " ", 1),
                  _createVNode(_unref(UiButton), {
                    small: "",
                    primary: "",
                    onClick: onInvoiceSave
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Zapisz " + _toDisplayString(_unref(invoiceFormMode) === _unref(InvoiceFormModes).EDIT ? ' zmiany' : ''), 1)
                    ]),
                    _: 1
                  })
                ]),
                (_unref(showValidationError))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Formularz zawiera błędy "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["text", "is-loading"])
      ]),
      _: 1
    })
  ], 64))
}
}

})